module.exports = __webpack_public_path__ + "img/covid.184e3292.jpg";